/* Eywa | Convert 'select' to 'dropdown' | Apr 26, 2017 */

$(document).ready(function(){

  $("#side-sortme dl.dropdown dt").click(function() {
    $("#side-sortme dl.dropdown dd ul").toggle();
  });
  
  $("#side-sortme dl.dropdown dd ul li a").click(function() {
    var text = $(this).html();
    $("#side-sortme .dropdown dt span").html(text);
    $("#side-sortme .dropdown dd ul").hide();
  });
  
  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (! $clicked.parents().hasClass("dropdown"))
        $("#side-sortme .dropdown dd ul").hide();
  });

});